export default __webpack_public_path__ + "static/media/facebook.d6e8979c.svg";